/**
 * Registry mapping a task type or context to the detail component that renders it.
 *
 * The generic task module stays domain-agnostic: it never imports a concrete
 * detail view. Each domain registers its renderer from its own registration
 * module (loaded eagerly at app bootstrap), so adding a domain never requires
 * editing this file or the dispatcher — you just register another entry.
 */

const DEFAULT_KEY = Symbol("default");

const registry = new Map();

// By type: wins over the context, for tasks that share another domain's context (the partner evaluation
// milestone is CONSTRUCTION for the Gantt)
const typeRegistry = new Map();

/** Register the detail component used for tasks with the given context. */
export const registerTaskDetail = (context, component) => {
    registry.set(context, component);
};

/** Register the detail component used for tasks of the given type, whatever their context. */
export const registerTaskTypeDetail = (type, component) => {
    typeRegistry.set(type, component);
};

/** Register the fallback detail component for contexts without a specific entry. */
export const registerDefaultTaskDetail = (component) => {
    registry.set(DEFAULT_KEY, component);
};

/** Resolve the detail component for a task: by type, then by context, then the default. */
export const resolveTaskDetail = (task) => {
    return typeRegistry.get(task.type) || registry.get(task.context) || registry.get(DEFAULT_KEY) || null;
};
